// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 7888) return "css/design_system-0ff9022a4046fed6.css";
if (chunkId === 1710) return "css/1710-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {1718: "25e43d52410aceac",2420: "1a063266965a6bad",2429: "fb6768e074e958b7",2504: "5e7c04a2b0740134",3641: "91ecc8e70b90fc55",370: "a8d311b114ec77ce",3802: "fff606c4f8ef08bd",424: "25e43d52410aceac",7019: "f1a491935b2509d8",9590: "25e43d52410aceac",}[chunkId] + ".css"
}